import { authAPI } from './auth';
import { budgetsAPI } from './budgets';

export async function settingsHubLoader() {
  const [meRes, methodRes] = await Promise.all([
    authAPI.fetchMe(),
    budgetsAPI.getActiveMethod(),
  ]);

  return {
    user: meRes.success ? meRes.data : null,
    activeMethod: methodRes.success ? methodRes.data : null,
  };
}
